<template>
  <div class="customer-bind">
    <form class="searcher" @submit.prevent="doSearch">
      <el-input type="text" size="small" v-model="form.phone" placeholder="请输入完整手机号" @blur="doCheck">
        <el-button slot="append" icon="el-icon-search" @click="doSearch"></el-button>
      </el-input>
    </form>
    <div v-if="errorMessage" style="text-align: center; line-height: 10; color: #9d9d9d;">{{ errorMessage }}</div>
    <div v-if="companyInfo && companyInfo.id" class="company-info">
      <div class="row">
        <div class="field col-sm-12">
          <label>名称</label>
          <div>{{ companyInfo.companyName }}</div>
        </div>
        <div class="field col-sm-12">
          <label>账号</label>
          <div>{{ companyInfo.phone }}</div>
        </div>
      </div>
      <div class="row">
        <div class="field col-sm-12">
          <label>上次活跃</label>
          <div v-if="companyInfo.lastActiveAt">{{ companyInfo.lastActiveAt | dateTimeFmt }}</div>
        </div>
        <div class="field col-sm-12">
          <label>状态</label>
          <div>
            {{
              companyInfo.state === 1 ? '正常' : '已禁用'
            }}
          </div>
        </div>
      </div>
      <div v-if="companyInfo.salerId" class="row">
        <div class="field col-sm-12">
          <label>关联销售</label>
          {{ companyInfo.salerName }}
        </div>
        <div class="field col-sm-12">
        </div>
      </div>
      <el-button v-else type="success" size="mini" class="bind-btn" @click="doBind">绑定</el-button>
    </div>
  </div>
</template>
<script>
import { searchCompanyByPhone, bind } from '../services'
export default {
  name: 'BindCustomer',
  data () {
    return {
      form: {
        phone: undefined
      },
      errorMessage: undefined,
      companyInfo: {
        id: undefined,
        companyName: undefined,
        phone: undefined,
        lastActiveAt: undefined,
        approveState: undefined,
        salerId: undefined,
        salerName: undefined
      }
    }
  },
  methods: {
    doSearch () {
      const mobileRegExp = new RegExp('^1[3-9]{1}[0-9]{9}')
      if (mobileRegExp.test(this.form.phone)) {
        searchCompanyByPhone(this.form.phone).then((resp) => {
          if (resp) {
            this.companyInfo = resp
          } else {
            this.errorMessage = '没找到对应客户'
          }
        })
      }
      return false
    },
    doCheck () {
      const mobileRegExp = new RegExp('^1[3-9]{1}[0-9]{9}')
      if (!mobileRegExp.test(this.form.phone)) {
        this.errorMessage = '请输入正确的手机号'
      } else {
        this.errorMessage = ''
      }
    },
    doBind () {
      bind(this.companyInfo.id).then(() => {
        this.$router.push('/customer')
      })
    }
  }
}
</script>
